import { endOfDay, subDays } from "date-fns";

export type CallDirection = "inbound" | "outbound" | "both";
export type DatePreset = "day" | "week" | "month";

export interface InsightsReportsFilters {
  callDirection: CallDirection;
  externalContact: string;
  customerPhone: string;
  taskQueues: string[];
  departments: string[];
  agents: string[];
  startDate: Date | undefined;
  endDate: Date | undefined;
  datePreset: DatePreset | undefined;
}

export function createDefaultInsightsFilters(): InsightsReportsFilters {
  return {
    callDirection: "both",
    externalContact: "",
    customerPhone: "",
    taskQueues: [],
    departments: [],
    agents: [],
    startDate: undefined,
    endDate: endOfDay(subDays(new Date(), 2)),
    datePreset: undefined,
  };
}

export function includesRecordingDelayPeriod(filters: InsightsReportsFilters, now = new Date()): boolean {
  const delayPeriodStart = endOfDay(subDays(now, 2)).getTime() + 1;
  const delayPeriodEnd = endOfDay(now).getTime();
  const rangeStart = filters.startDate?.getTime() ?? Number.NEGATIVE_INFINITY;
  const rangeEnd = filters.endDate?.getTime() ?? Number.POSITIVE_INFINITY;

  return rangeStart <= delayPeriodEnd && rangeEnd >= delayPeriodStart;
}
